import React from 'react'
import './CreateRequisition.css';
import PageTitle from '../global/PageTitle/PageTitle'
export default function CreateRequisition() {
  return (
    <div class ="create-req">
       <PageTitle title="Create Requisition" />
       <div className='create-req-header'>
    <div className='header-field'>
       <h4> Company</h4>
    <div className='h-f'>  LTFCORP Life Time, Inc </div> 

    </div>
    <div classNam='header-field'>
       <h4>Requester</h4>
    <div className='h-f'> Test Change (9003358)[C] </div> 

    </div>
    <div classNam='header-field'>
       <h4>Currency</h4>
    <div className='h-f'> USD</div> 

    </div></div>

     <div className='search-fields'>
    <a className="req-link" href="/search-catalog">Search Catalog</a><br/>
   <div className='req-field'> Search the internal catalog of preferred items and suppliers to add into shopping cart </div>
   <br/></div>
<hr/>
<div className='search-fields'>
<a className="req-link" href="#">Request Non -Catalog items</a><br/>
   <div className='req-field'> Request services or Repair & Maintenance </div>
   <br/>
<hr/></div>
<div className='search-fields'>
<a className="req-link" href="#">Connect to supplier Website</a><br/>
   <div className='req-field'> Request goods and services from supplier website </div>
   <br/>
<hr/></div>
    </div>
  )
}